import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from '../card/card.module';
import { ProtocolProvisioningComponent } from './protocol-provisioning.component';
import { PaceForms2Module } from '@evorait/pace-forms';

@NgModule({
    declarations: [ProtocolProvisioningComponent],
    imports: [
        CommonModule,
        CardModule,
        FormsModule,
        LetDirective,
        PushPipe,
        TranslateModule.forChild(),
        ReactiveFormsModule,
        PaceForms2Module.forChild(),
    ],
    exports: [ProtocolProvisioningComponent],
})
export class ProtocolProvisioningModule {}
